.overlay-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: rgb(0, 0, 0);
    width: calc(100% - 100px);
    height: 75px;
    color: white;
    font-size: 17px;
    border-radius: 5px;
}

.section-container {
    background-color: var(--off-white);
    margin-bottom: 16px;
    padding: 16px;
    box-sizing: border-box;
}

.section-container--no-margin {
    composes: section-container;
    margin: 0;
    height: 100%;
}
